var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[(_vm.$route.params.mode == 'add')?_c('add'):_vm._e(),(_vm.$route.params.mode == 'edit')?_c('edit'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }